import { type PreferredProductData } from "../models/PdpPageProductData";
import { resolveApiUrl } from "../../utils/url/urlResolver";
import type { SearchProductDataDTO } from "~/Search/dto/SearchResultsDTO";
import { transformSrpProduct } from "~/Search/transformers/transformSrpProduct";
import type { SrpProductData } from "~/utils/models";

type NewResultType = {
  preferred: PreferredProductData[];
  sales: SrpProductData[];
};

export async function fetchPreferredProducts(productCode: string): Promise<NewResultType> {
  const apiUrl = resolveApiUrl(`/p/${productCode}/preferred`);

  const response = await fetch(apiUrl, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  });
  if (response.redirected) {
    window.location.reload();
  } else if (response.ok) {
    const data = await response.json();
    if (Array.isArray(data)) {
      return {
        preferred: data as PreferredProductData[],
        sales: [],
      };
    } else {
      return {
        preferred: data.preferredProducts as PreferredProductData[],
        sales: (data.productsOnSale ?? []).map((product: unknown) =>
          transformSrpProduct(product as SearchProductDataDTO),
        ),
      };
    }
  }
  throw new Error("Error fetching data");
}
